import { getLocationSearchToObject } from '../../utils/format';

export default function() {
  const params = getLocationSearchToObject();
  let enablePromo = true;
  if (params && params.email) {
    enablePromo = false;
  }

  if (enablePromo) {
    const modalNamespace = 'promo-modal';
    const modal = window.modalManager.idModalMap.get(modalNamespace);

    if (modal) {
      const { namespace } = modal.element.dataset;
      const cookieName = `promo-${namespace}`;
      const cookieIsSet = window.localStorage.getItem(cookieName);

      if (!cookieIsSet) {
        modal.show();
        modal.on('hide', () => {
          window.localStorage.setItem(cookieName, true);
        });
      }
    }
  }
}
